import {Container, Graphics, Sprite, Text, TextStyle} from "pixi.js";
import ICreate from "../interfaces/ICreate.ts";
import IDestroy from "../interfaces/IDestroy.ts";
import IHighlight from "../interfaces/IHighlight.ts";
import MarkText from "../components/MarkText.ts";
import gsap from "gsap";
import SplitText from "../components/SplitText.ts";
import RhColors from "@/models/RhColors.ts";
import MarkUtil from "@/utils/MarkUtil.ts";
import DagobahModel from "@/models/DagobahModel.ts";
import TimelineManager from "@/managers/TimelineManager.ts";

export default class Mark extends Container implements ICreate, IDestroy, IHighlight
{
    public color:string;
    public fontSize:number;
    public highlightColor:string;
    public markHeight:number;
    public markWidth:number;
    public markX:number;
    public markY:number;
    public parentTarget:MarkText;
    public size:number;
    public strokeThickness:number;

    protected _targetX:number;
    protected _targetY:number;
    protected mark:Graphics | Sprite | Text | Container;
    protected markHighlight:Graphics | Sprite | Text | Container;
    protected multipleOfDefaultFontSize:number;
    protected padding:number;
    protected sizeMultipleOfText:number;
    protected strokeMultipleOfText:number;
    protected targetSplitText:SplitText;
    protected targetTextField:MarkText;
    protected targetTextFieldStyle:TextStyle;

	public get targetX():number
	{
		if(this._targetX == undefined)
        {
            if(this.targetTextField)
            {
            	this.targetTextField.x;
            }
            else
            {
                this._targetX = 0;
            }
        }
        return this._targetX;
    }

    public get targetY():number
    {
        if(this._targetY == undefined)
        {
            if(this.targetTextField)
            {
                this.targetTextField.y;
            }
            else
            {
                this._targetY = 0;
            }
        }
        return this._targetY;
    }

    public get textScale():number
    {
        let scale = 1;
        if(this.targetTextField)
        {
            const curFontSize = Number(this.targetTextField.style.fontSize);
            scale = curFontSize/SplitText.DECODING_DEFAULT;
        }
        return scale;
    }

    constructor(color:string)
    {
    	super();
        this.color = color;
        this.fontSize = 72;
        this.highlightColor = RhColors.HIGHLIGHT_PRIMARY;//"#00E2FF";
        this.markHeight = 32;
        this.markWidth = 32;
        this.markX = 0;
        this.markY = 0;
        this.multipleOfDefaultFontSize = SplitText.DECODING_DEFAULT/SplitText.DECODING_SINGLE_SYLLABIC;
        this.padding = 0;
        this.sizeMultipleOfText = 0.236;
        this.strokeMultipleOfText = 0.036;
        this.strokeThickness = 5;
    }

    public adjustToScale(value:number):number
    {
        return value*this.textScale;
    }

    public create():void
    {
        throw new Error("create method not implemented.");
    }

    public override destroy():void
    {
        this.removeChildren();
        this.mark = null;
        this.markHighlight = null;
        this.targetTextField = null;
        this.targetTextFieldStyle = null;
        this.parentTarget = null;
        super.destroy();
    }

    protected hasAscender(character:string):boolean
    {
        let charHasAscender:boolean = true;
        switch (character)
        {
            case "a":
            case "c":
            case "e":
            case "g":
            case "m":
            case "n":
            case "o":
            case "p":
            case "q":
            case "r":
            case "s":
            case "u":
            case "v":
            case "w":
            case "x":
            case "y":
            case "z":
                charHasAscender = false;
                break;
        }
        return charHasAscender;
    }

    protected hasAscenderTwoLetters(characters:string):boolean
    {
        let hasAscender:boolean = false;
        switch (characters)
        {
            case "ch":
            case "ck":
            case "ph":
            case "sh":
            case "th":
            case "wh":
                hasAscender = true;
                break;
        }
        return hasAscender;
    }

    protected hasAscenderThreeLetters(characters:string):boolean
    {
        let hasAscender:boolean = false;
        switch (characters)
        {
            case "tch":
            case "dge":
                hasAscender = true;
                break;
        }
        return hasAscender;
    }

    protected hasDescender(character:string):boolean
    {
        let charHasDescender:boolean = false;
        switch (character)
        {
            case "g":
            case "j":
            case "p":
            case "y":
                charHasDescender = true;
                break;
        }
        return charHasDescender;
    }

    public highlight():void
    {
        this.markHighlight.alpha = 0;
        this.markHighlight.visible = true;
        TimelineManager.to(this.markHighlight, {alpha:1, duration:0.5});
    }

    public unhighlight():void
    {
        TimelineManager.to(this.markHighlight, {
            alpha: 0,
            duration: 0.5,
            onComplete: () => {
                this.markHighlight.visible = false;
            },
        });
    }
    
}
